import CalendarsPages from './subPages/calendars';
import CalendarCategoriesPages from './subPages/calendarCategories';
import FootfallPages from './subPages/footfall';
import InvoicesSalesVillagePages from './subPages/invoicesSalesVillage';
import InvoicesCompareFootfallSalesPages from './subPages/invoicesCompareFootfallSales';
import InvoicesConversionRateVillagePages from './subPages/invoicesConversionRateVillage';
import InvoicesAtvVillagePages from './subPages/invoicesAtvVillage';
import InvoicesUptVillagePages from './subPages/invoicesUptVillage';
import InvoicesPiecesPages from './subPages/invoicesPieces';
import InvoicesTicketsPages from './subPages/invoicesTickets';
import KpiPages from './subPages/kpi';
import KpiWeekdaysHolidaysPages from './subPages/kpiWeekdaysHolidays';
import ConsumiNetSalesPages from './subPages/consumiNetSales';
import InvoicesCategoryPiecesPages from './subPages/invoicesCategoryPieces';
import StoreVsVillagePages from './subPages/storeVsVillage';
import FootfallStoreVsVillagePages from './subPages/footfallStoreVsVillage';
import InvoicesSalesCompetitorsPages from './subPages/invoicesSalesCompetitors';
import InvoicesSalesTrendsPages from './subPages/invoicesSalesTrends';
import SalesTrackingsGenderAgePages from './subPages/salesTrackingsGenderAge';
import SalesTrackingsGenderBrandPages from './subPages/salesTrackingsGenderBrand';
import InvoicesCategoryTicketsPages from './subPages/invoicesCategoryTickets';
import AllReports from './subPages/allReports';
import VipClubPages from './subPages/vipClub';

const routes = [
  {
    path: '/calendars/*',
    canUse: [],
    Component: CalendarsPages,
  },
  {
    path: '/calendar_categories/*',
    canUse: [],
    Component: CalendarCategoriesPages,
  },
  {
    path: '/footfall/*',
    canUse: [],
    Component: FootfallPages,
    hideLayout: ['analytics/footfall/print'],
  },
  {
    path: '/invoices_sales_village/*',
    canUse: [],
    Component: InvoicesSalesVillagePages,
    hideLayout: ['analytics/invoices_sales_village/print'],
  },
  {
    path: '/invoices_compare_footfall_sales/*',
    canUse: [],
    Component: InvoicesCompareFootfallSalesPages,
    hideLayout: ['analytics/invoices_compare_footfall_sales/print'],
  },
  {
    path: '/invoices_conversion_rate_village/*',
    canUse: [],
    Component: InvoicesConversionRateVillagePages,
    hideLayout: ['analytics/invoices_conversion_rate_village/print'],
  },
  {
    path: '/invoices_atv_village/*',
    canUse: [],
    Component: InvoicesAtvVillagePages,
    hideLayout: ['analytics/invoices_atv_village/print'],
  },
  {
    path: '/invoices_upt_village/*',
    canUse: [],
    Component: InvoicesUptVillagePages,
    hideLayout: ['analytics/invoices_upt_village/print'],
  },
  {
    path: '/invoices_pieces/*',
    canUse: [],
    Component: InvoicesPiecesPages,
    hideLayout: ['analytics/invoices_pieces/print'],
  },
  {
    path: '/invoices_tickets/*',
    canUse: [],
    Component: InvoicesTicketsPages,
    hideLayout: ['analytics/invoices_tickets/print'],
  },
  {
    path: '/kpi/*',
    canUse: [],
    Component: KpiPages,
    hideLayout: ['analytics/kpi/print'],
  },
  {
    path: '/weekdays_holidays_kpi/*',
    canUse: [],
    Component: KpiWeekdaysHolidaysPages,
    hideLayout: ['analytics/weekdays_holidays_kpi/print'],
  },
  {
    path: '/consumi_net_sales/*',
    canUse: [],
    Component: ConsumiNetSalesPages,
    hideLayout: ['analytics/consumi_net_sales/print'],
  },
  {
    path: '/invoices_category_pieces/*',
    canUse: [],
    Component: InvoicesCategoryPiecesPages,
    hideLayout: ['analytics/invoices_category_pieces/print'],
  },
  {
    path: '/invoices_category_tickets/*',
    canUse: [],
    Component: InvoicesCategoryTicketsPages,
    hideLayout: ['analytics/invoices_category_tickets/print'],
  },
  {
    path: '/store_vs_village-sales-trends/*',
    canUse: [],
    Component: StoreVsVillagePages,
    hideLayout: ['analytics/store_vs_village-sales-trends/print'],
  },
  {
    path: '/store_vs_village-footfall/*',
    canUse: [],
    Component: FootfallStoreVsVillagePages,
    hideLayout: ['analytics/store_vs_village-footfall/print'],
  },
  {
    path: '/invoices_sales_competitors/*',
    canUse: [],
    Component: InvoicesSalesCompetitorsPages,
    hideLayout: ['analytics/invoices_sales_competitors/print'],
  },
  {
    path: '/invoices_sales_trends/*',
    canUse: [],
    Component: InvoicesSalesTrendsPages,
    hideLayout: ['analytics/invoices_sales_trends/print'],
  },
  {
    path: '/sales_trackings_gender_age/*',
    canUse: [],
    Component: SalesTrackingsGenderAgePages,
    hideLayout: ['analytics/sales_trackings_gender_age/print'],
  },
  {
    path: '/sales_trackings_gender_brand/*',
    canUse: [],
    Component: SalesTrackingsGenderBrandPages,
    hideLayout: ['analytics/sales_trackings_gender_brand/print'],
  },
  {
    path: '/vip_club/*',
    canUse: [],
    Component: VipClubPages,
    hideLayout: ['analytics/vip_club/print'],
  },
  {
    path: '/export/*',
    canUse: [],
    Component: AllReports,
    hideLayout: ['analytics/export/print'],
  },
];

export default routes;
